class EventService {
  private static instance: EventService;
  private queue: Object;
  private eventHistory: Object;

  private constructor() {
    this.queue = {};
    this.eventHistory = {};
  }

  public static getInstance(): EventService {
    if (!EventService.instance) EventService.instance = new EventService();
    return EventService.instance;
  }

  public subscribe(event: string, callback: Function, fireHistorically: boolean = true) {
    // Create the event's object if not yet created
    if (this.queue[event] === undefined) this.queue[event] = [];

    // Add the callback to queue
    let index = this.queue[event].push(callback) - 1;

    // Fire the callback if an event historically exists
    if (fireHistorically && this.eventHistory[event] !== undefined) {
        callback(this.eventHistory[event]);
    }

    // Provide handle back for removal of event
    return {
      remove: () => {
        delete this.queue[event][index];
      }
    };
  }

  public fire(event: string, info: any) {
    // Save the latest event info
    this.eventHistory[event] = info;

    // If the event doesn't exist, or there are no callbacks in queue, just leave
    if (this.queue[event] === undefined) return;

    // Cycle through queue, fire!
    this.queue[event].forEach(callback => {
      callback(info != undefined ? info : {});
    });
  }
}

export default EventService.getInstance();